module.exports = __webpack_public_path__ + "static/media/object-ungroup.dbd57749.svg";